(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("cV6ox", function(module, exports) {

$parcel$export(module.exports, "filtersHandler", function () { return $967fc4c6422a8cbd$export$a29349ec4545b7b4; });
// Job openings filters
const $967fc4c6422a8cbd$var$filterResults = (departmentFilter, locationFilter)=>{
    if (locationFilter == 'none') {
        jQuery('.job-openings__department__opening').show();
        if (departmentFilter == 0) jQuery('.job-openings__department').show();
        else {
            jQuery('.job-openings__department[department_id="' + departmentFilter + '"]').show();
            jQuery('.job-openings__department[department_id="' + departmentFilter + '"]').children().show();
        }
    } else if (departmentFilter == 0) {
        jQuery('.job-openings__department__opening[location_id="' + locationFilter + '"]').parent().show();
        jQuery('.job-openings__department__opening[location_id="' + locationFilter + '"]').show();
    } else {
        jQuery('.job-openings__department[department_id="' + departmentFilter + '"] .job-openings__department__opening[location_id="' + locationFilter + '"]').parent().show();
        jQuery('.job-openings__department[department_id="' + departmentFilter + '"] .job-openings__department__opening[location_id="' + locationFilter + '"]').show();
    }
};
const $967fc4c6422a8cbd$export$a29349ec4545b7b4 = ()=>{
    jQuery(document).ready(function($) {
        jQuery('.filter').change(function(event) {
            departmentFilterValue = jQuery('.filter--department').find(":selected").val();
            locationFilterValue = jQuery('.filter--location').find(":selected").val();
            jQuery('.job-openings__department').hide();
            jQuery('.job-openings__department__opening').hide();
            $967fc4c6422a8cbd$var$filterResults(departmentFilterValue, locationFilterValue);
        });
    });
};

});

})();
//# sourceMappingURL=careers-greenhouse-filters.7946e741.js.map
